import { FC } from 'react';

import { Tag } from '@servicetitan/design-system';

import { AppReviewStatus } from '../../api/app.api';

const colorByReviewStatus: Record<AppReviewStatus, 'warning' | 'critical' | 'success'> = {
    [AppReviewStatus.EvaluationInProgress]: 'warning',
    [AppReviewStatus.Rejected]: 'critical',
    [AppReviewStatus.Approved]: 'success',
};

const labelByReviewStatus: Record<AppReviewStatus, string> = {
    [AppReviewStatus.EvaluationInProgress]: 'Evaluation In Progress',
    [AppReviewStatus.Rejected]: 'Rejected',
    [AppReviewStatus.Approved]: 'Approved',
};

export interface AppReviewStatusTagProps {
    reviewStatus: AppReviewStatus;
}

export const AppReviewStatusTag: FC<AppReviewStatusTagProps> = ({ reviewStatus }) => (
    <Tag color={colorByReviewStatus[reviewStatus]} subtle>
        {labelByReviewStatus[reviewStatus]}
    </Tag>
);
AppReviewStatusTag.displayName = 'AppReviewStatusTag';
